export default {
  "account": {
    "curatedCollections": "Collezioni curate",
    "curatedCollectionsInfo": "Trova di seguito tutte le collezioni che hai curato",
    "editProfile": "Modifica Profilo",
    "likes": "Mi piace",
    "linkAccount": "Il mio account",
    "linkLogin": "Accedi",
    "linkLoginJoin": "Accedi/Iscriviti",
    "linkLogout": "Esci",
    "myProfile": "Il mio profilo",
    "notifications": {
      "loggedIn": "Ora sei loggato. Benvenuto!",
      "loggedOut": "Sei ora disconnesso.",
      "noCollections": {
        "curated": "Non hai ancora curato nessuna collezione",
        "private": "Non hai ancora creato gallerie private",
        "public": "Non hai ancora creato gallerie pubbliche"
      },
      "noLikedItems": "Non hai ancora messo Mi piace a nessun oggetti"
    },
    "privateCollections": "Gallerie private",
    "profile": "I miei Mi piace e le mie gallerie",
    "profileSettings": "Impostazioni del profilo",
    "publicCollections": "Gallerie pubbliche",
    "settings": "Impostazioni",
    "title": "Il mio account"
  },
  "actions": {
    "accept": "Accettare",
    "cancel": "Annulla",
    "close": "chiudi",
    "continue": "continua",
    "download": "Scarica",
    "edit": "Modifica",
    "feedback": "Feedback",
    "goBack": "Indietro",
    "goHome": "Vai alla homepage",
    "learnMore": "Per saperne di più",
    "like": "Mi piace",
    "move": "Spostare",
    "next": "Prossimo",
    "pin": "Spilla",
    "preview": "Anteprima",
    "previous": "Precedente",
    "providedBy": "Fornito da {provider}",
    "reject": "Rifiuta",
    "save": "Salva",
    "send": "Invia",
    "share": "Condividi",
    "shareOn": "Condividi su {social}",
    "skip": "Salta",
    "viewAt": "Vedi su {link}",
    "viewDocument": "Visualizza documento"
  },
  "attribution": {
    "country": "Paese:",
    "creator": "Creatore:",
    "date": "Data:",
    "institution": "Istituzione:",
    "title": "Titolo:"
  },
  "automatedCardGroup": {
    "item": "Oggetti recenti",
    "organisation": "Organizzazioni",
    "place": "Posti",
    "time": "Secoli in primo piano",
    "topic": "Argomenti in primo piano"
  },
  "blog": {
    "author": "Autore",
    "authors": "Autori",
    "blog": "Blog",
    "by": "di",
    "categories": "Categorie",
    "category": "Categoria",
    "posts": "Articoli del blog",
    "published": "Pubblicato il giorno {date}",
    "relatedPosts": "Articoli correlati"
  },
  "cardLabels": {
    "organisation": "Organizzazione",
    "person": "Persona",
    "place": "Luogo",
    "theme": "Tema",
    "time": "Secolo",
    "topic": "Argomento"
  },
  "clearAllFilters": "cancella tutti i filtri",
  "collections": {
    "actions": {
      "edit": "Modifica raccolta",
      "update": "Aggiorna raccolta"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "designer",
          "name": "Designer | Designer",
          "select": "Seleziona designer"
        },
        "proxy_dc_format": {
          "moreName": "tecniche",
          "name": "Tecnica | Tecniche",
          "select": "Seleziona le tecniche"
        },
        "proxy_dc_type": {
          "moreName": "tipi di articoli",
          "name": "Tipo di elemento | Tipi di elementi",
          "select": "Seleziona i tipi di articoli"
        },
        "proxy_dcterms_medium": {
          "moreName": "materiali",
          "name": "Materiale | Materiali",
          "select": "Seleziona i materiali"
        }
      }
    },
    "form": {
      "description": "Descrizione"
    },
    "notifications": {
      "update": "La collezione è stata aggiornata"
    }
  },
  "collectionsYouMightLike": "Collezioni che potrebbero piacerti",
  "colourSwatch": "Campione di colore",
  "contentYouMightLike": "Contenuto che potrebbe piacerti",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Maggiori informazioni",
      "about": "Le collezioni Europeana",
      "forDevelopers": "Per gli sviluppatori",
      "help": "Aiuto",
      "meetUs": "La nostra squadra",
      "provide": "Diventa un fornitore di dati",
      "subscribe": "Iscriviti alla newsletter",
      "terms": "Termini del servizio e Informativa sulla privacy"
    },
    "headerNavigation": {
      "Collections": "Collezioni",
      "explore": "Esplora",
      "teachers": "Insegnanti"
    }
  },
  "curatedAutomatically": "Curato automaticamente da Europeana",
  "dateFilter": {
    "endDate": "Data di fine",
    "specificDate": "Data specifica",
    "startDate": "Data di inizio",
    "to": "a"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Chiave API Europeana",
      "noRequests": "In questa pagina non sono state utilizzate richieste alle API di Europeana.",
      "settingsPageLinkText": "pagina delle impostazioni",
      "tip": "Suggerimento: se hai già un {apiKeyLink} , puoi inserirlo in {settingsPageLink} e sarà incluso in questi link di richiesta API.",
      "title": "Richieste API"
    },
    "debug": "Debug",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Inserisci la tua chiave API Europeana e verrà utilizzata nei link alle richieste API.",
          "label": "Chiave API"
        },
        "enabled": {
          "description": "Se abilitato, il menu di debug verrà mostrato nel piè di pagina della pagina.",
          "label": "Abilita menu di debug"
        }
      },
      "title": "Impostazioni"
    }
  },
  "delete": "Cancella",
  "depiction": "Una rappresentazione di {title}",
  "directions": {
    "left": "Sinistra",
    "right": "Destra"
  },
  "edmIsShownAtLinkAlt": "Visualizza sul sito web del fornitore",
  "entity": {
    "actions": {
      "cancel": "Annulla",
      "pin": "Elemento pin",
      "unpin": "Rimuovi elemento",
      "viewPinned": "Visualizza gli oggetti appuntati"
    },
    "labels": {
      "entity": "Entità"
    },
    "notifications": {
      "deleted": "Galleria eliminata.",
      "error": {
        "unpin": "Si è verificato un errore durante lo sblocco dell'elemento. Riprova o segnala il problema."
      },
      "pin": "Questo elemento verrà visualizzato nella parte superiore della raccolta \" {entity} \". Ti avviseremo quando questa modifica sarà visibile nella pagina di raccolta.",
      "pinLimit": {
        "body": "Per ora puoi appuntare solo 24 oggetti nella prima pagina. Se vuoi appuntare questo elemento, assicurati di sbloccarne un altro e poi prova ad appuntare di nuovo questo.",
        "title": "Troppi oggetti appuntati"
      },
      "pinned": "L'articolo è stato appuntato. Ora è in cima alla prima pagina di questa collezione. Potrebbe richiedere fino a 24 ore per apparire per tutti.",
      "select": "Seleziona un'entità correlata a cui aggiungere/sbloccare l'elemento a/da esso.",
      "unpin": "Questo elemento non verrà più visualizzato nella parte superiore della raccolta \" {entity} \". Ti avviseremo quando questa modifica sarà visibile nella pagina di raccolta.",
      "unpinned": "L'elemento è stato sbloccato. Non è più in cima alla prima pagina di questa raccolta. Potrebbero essere necessarie fino a 24 ore per scomparire per tutti."
    }
  },
  "error": "Errore",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Questo non è possibile perché le gallerie private sono visibili solo al loro creatore. Se conosci il creatore della galleria, chiedigli di rendere pubblica la galleria. In alternativa, segnala questo problema utilizzando il pulsante di feedback.",
      "metaTitle": "Galleria non autorizzata",
      "title": "Oops! {newline} Stai tentando di visualizzare la galleria privata di un'altra persona."
    },
    "itemNotFound": {
      "description": "Ciò potrebbe essere dovuto ai seguenti motivi: questo elemento non esiste, o; è stato ritirato dalla pubblicazione perché non corrispondeva ai nostri criteri di qualità, oppure; è stato aggiornato e ripubblicato con un nuovo identificatore univoco, nel qual caso prova a ritrovare l'elemento.",
      "metaTitle": "Elemento non trovato",
      "title": "Oh no! {newline} Non siamo riusciti a trovare questo elemento."
    }
  },
  "exhibitions": {
    "chapters": "Capitoli",
    "credits": "Realizzato da",
    "currentChapter": "Capitolo attuale",
    "description": "Esplora le mostre",
    "exhibitions": "Mostre"
  },
  "explore": "Esplorare",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "colori",
      "name": "Colore | Colori",
      "options": {
        "#000000": "Nero",
        "#000080": "Blu navy",
        "#00008B": "Blu scuro",
        "#0000CD": "Blu medio",
        "#0000FF": "Blu",
        "#006400": "Verde scuro",
        "#008000": "Web verde",
        "#008080": "Teal",
        "#008B8B": "Ciano scuro",
        "#00BFFF": "Deep Sky Blue",
        "#00CED1": "Turchese scuro",
        "#00FA9A": "Verde medio primaverile",
        "#00FF00": "verde",
        "#00FF7F": "Verde primavera",
        "#00FFFF": "Ciano",
        "#191970": "Blu notte",
        "#1E90FF": "Blu Dodger",
        "#20B2AA": "Light Sea Green",
        "#228B22": "Verde foresta",
        "#2E8B57": "Mare verde",
        "#2F4F4F": "Grigio ardesia scuro",
        "#32CD32": "Verde lime",
        "#3CB371": "Verde Mare Medio",
        "#40E0D0": "Turchese",
        "#4169E1": "Blu Reale",
        "#4682B4": "Blu acciaio",
        "#483D8B": "Blu ardesia scuro",
        "#48D1CC": "Turchese medio",
        "#4B0082": "Indaco",
        "#556B2F": "Verde oliva scuro",
        "#5F9EA0": "Cadetto Blu",
        "#6495ED": "Fiordaliso",
        "#663399": "Rebecca Purple",
        "#66CDAA": "Acquamarina media",
        "#696969": "Grigio scuro",
        "#6A5ACD": "Blu ardesia",
        "#6B8E23": "Verde olivastro",
        "#708090": "Grigio ardesia",
        "#778899": "Grigio ardesia chiaro",
        "#7B68EE": "Blu medio ardesia",
        "#7CFC00": "Verde prato",
        "#7F0000": "Web marrone rossiccio",
        "#7F007F": "Web viola",
        "#7FFF00": "certosa",
        "#7FFFD4": "Acquamarina",
        "#800000": "Bordeaux",
        "#800080": "Viola",
        "#808000": "Oliva",
        "#808080": "Web grigio",
        "#87CEEB": "Cielo blu",
        "#87CEFA": "Azzurro cielo",
        "#8A2BE2": "Blu viola",
        "#8B0000": "Rosso scuro",
        "#8B008B": "Magenta scuro",
        "#8B4513": "Marrone cuoio",
        "#8FBC8F": "Dark Sea Green",
        "#90EE90": "Verde chiaro",
        "#9370DB": "Viola medio",
        "#9400D3": "Viola scuro",
        "#98FB98": "Verde pallido",
        "#9932CC": "Orchidea scuro",
        "#9ACD32": "Giallo verde",
        "#A020F0": "Viola",
        "#A0522D": "Terra di Siena",
        "#A52A2A": "Marrone",
        "#A9A9A9": "Grigio scuro",
        "#ADD8E6": "Azzurro",
        "#ADFF2F": "Verde giallo",
        "#AFEEEE": "Turchese pallido",
        "#B03060": "Bordeaux",
        "#B0C4DE": "Azzurro acciaio",
        "#B0E0E6": "Blu polvere",
        "#B22222": "Firebrick",
        "#B8860B": "Solidago scuro",
        "#BA55D3": "Orchidea medio",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Dark Khaki",
        "#BEBEBE": "Grigio",
        "#C0C0C0": "Argento",
        "#C71585": "Magenta",
        "#CD5C5C": "Rosso indiano",
        "#CD853F": "Perù",
        "#D2691E": "Cioccolato",
        "#D2B48C": "abbronzatura",
        "#D3D3D3": "Grigio chiaro",
        "#D8BFD8": "Cardo",
        "#DA70D6": "Orchidea",
        "#DAA520": "Verga d'oro",
        "#DB7093": "Pallido Viola Rosso",
        "#DC143C": "Cremisi",
        "#DCDCDC": "Grigio gainsboro",
        "#DDA0DD": "prugna",
        "#DEB887": "burlywood",
        "#E0FFFF": "Ciano chiaro",
        "#E6E6FA": "Lavanda",
        "#E9967A": "Salmone Scuro",
        "#EE82EE": "Viola",
        "#EEE8AA": "Verga d'oro pallido",
        "#F08080": "Corallo chiaro",
        "#F0E68C": "Cachi",
        "#F0F8FF": "Blu Alice",
        "#F0FFF0": "Melata",
        "#F0FFFF": "Azzurro",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Grano",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Fumo bianco",
        "#F5FFFA": "Crema Di Menta",
        "#F8F8FF": "Ghost White",
        "#FA8072": "salmone",
        "#FAEBD7": "Bianco antico",
        "#FAF0E6": "Biancheria",
        "#FAFAD2": "Verga d'oro",
        "#FDF5E6": "Bianco avorio",
        "#FF0000": "Rosso",
        "#FF00FF": "Fucsia",
        "#FF1493": "Rosa scuro",
        "#FF4500": "Rosso-arancio",
        "#FF6347": "Pomodoro",
        "#FF69B4": "Fucsia",
        "#FF7F50": "Corallo",
        "#FF8C00": "Arancione scuro",
        "#FFA07A": "Salmone chiaro",
        "#FFA500": "arancia",
        "#FFB6C1": "Rosa chiaro",
        "#FFC0CB": "Rosa",
        "#FFD700": "Oro",
        "#FFDAB9": "Pesca scuro",
        "#FFDEAD": "Navajo White",
        "#FFE4B5": "Camoscio",
        "#FFE4C4": "Biscotto",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Mandorla Sbiancata",
        "#FFEFD5": "Frusta di papaia",
        "#FFF0F5": "Fard lavanda",
        "#FFF5EE": "Conchiglia",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Chiffon al limone",
        "#FFFAF0": "Floreale bianco",
        "#FFFAFA": "Neve",
        "#FFFF00": "Giallo",
        "#FFFFE0": "Giallo chiaro",
        "#FFFFF0": "Avorio",
        "#FFFFFF": "bianca"
      },
      "select": "Seleziona i colori"
    },
    "COUNTRY": {
      "name": "Paese fornitore",
      "options": {
        "Albania": "Albania",
        "Austria": "Austria",
        "Belarus": "Bielorussia",
        "Belgium": "Belgio",
        "Bosnia and Herzegovina": "Bosnia ed Erzegovina",
        "Bulgaria": "Bulgaria",
        "Croatia": "Croazia",
        "Cyprus": "Cipro",
        "Czech Republic": "Repubblica Ceca",
        "Denmark": "Danimarca",
        "Estonia": "Estonia",
        "Europe": "Europa",
        "Finland": "Finlandia",
        "France": "Francia",
        "Georgia": "Georgia",
        "Germany": "Germania",
        "Greece": "Grecia",
        "Holy See (Vatican City State)": "Santa Sede (Stato della Città del Vaticano)",
        "Hungary": "Ungheria",
        "Iceland": "Islanda",
        "Ireland": "Irlanda",
        "Israel": "Israele",
        "Italy": "Italia",
        "Latvia": "Lettonia",
        "Lithuania": "Lituania",
        "Luxembourg": "Lussemburgo",
        "Macedonia": "Macedonia",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Montenegro",
        "Netherlands": "Paesi Bassi",
        "Norway": "Norvegia",
        "Poland": "Polonia",
        "Portugal": "Portogallo",
        "Romania": "Romania",
        "Russia": "Russia",
        "Serbia": "Serbia",
        "Slovakia": "Slovacchia",
        "Slovenia": "Slovenia",
        "Spain": "Spagna",
        "Sweden": "Svezia",
        "Switzerland": "Svizzera",
        "Turkey": "Turchia",
        "Ukraine": "Ucraina",
        "United Kingdom": "Regno Unito",
        "United States of America": "Stati Uniti d'America"
      },
      "select": "Seleziona i paesi fornitori"
    },
    "CREATOR": {
      "moreName": "creatori",
      "name": "Creatore | Creatori",
      "select": "Seleziona i creatori"
    },
    "DATA_PROVIDER": {
      "moreName": "istituzioni",
      "name": "Istituzione",
      "select": "Seleziona le istituzioni"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Orientamento immagine | Orientamenti immagini",
      "options": {
        "landscape": "Paesaggio",
        "portrait": "Ritratto"
      },
      "select": "Seleziona gli orientamenti dell'immagine"
    },
    "IMAGE_SIZE": {
      "name": "Dimensioni immagine | Dimensioni immagini",
      "options": {
        "extra_large": "Molto grande > 4 MP (es. 1920x1080 px)",
        "large": "Grande 1-4 MP (es. 1920x1080 px)",
        "medium": "Media 0,5-1 MP (es. 850x850 px)",
        "small": "Piccola < 0,5 MP (es. 650x600 px)"
      },
      "select": "Seleziona le dimensioni dell'immagine"
    },
    "LANGUAGE": {
      "name": "Lingua",
      "options": {
        "ar": "Arabo",
        "bg": "Bulgaro",
        "bs": "Bosniaco",
        "ca": "Catalano",
        "cs": "Ceco",
        "cy": "Gallese",
        "da": "Danese",
        "de": "Tedesco",
        "el": "Greco",
        "en": "Inglese",
        "es": "Spagnolo",
        "et": "Estone",
        "fi": "Finlandese",
        "fr": "Francese",
        "ga": "Irlandese",
        "gd": "Gaelico",
        "he": "Ebraico",
        "hr": "Croato",
        "hu": "Ungherese",
        "is": "Islandese",
        "it": "Italiano",
        "lt": "Lituano",
        "lv": "Lettone",
        "mk": "Macedone",
        "mt": "Maltese",
        "mul": "Più lingue",
        "nl": "Olandese",
        "no": "Norvegese",
        "pl": "Polacco",
        "pt": "Portoghese",
        "ro": "Rumeno",
        "ru": "Russo",
        "sk": "Slovacco",
        "sl": "Sloveno",
        "sq": "Albanese",
        "sr": "Serbo",
        "sv": "Svedese",
        "tr": "Turco",
        "uk": "Ucraino"
      },
      "select": "Seleziona le lingue"
    },
    "MIME_TYPE": {
      "name": "Formato file | Formati file",
      "options": {
        "text/plain": "Testo semplice"
      },
      "select": "Seleziona i formati di file"
    },
    "PROVIDER": {
      "moreName": "aggregatori",
      "name": "Aggregatore",
      "select": "Seleziona aggregatori"
    },
    "REUSABILITY": {
      "name": "Posso riutilizzarlo?",
      "options": {
        "open": "Sì",
        "permission": "Forse, meglio chiedere il permesso",
        "restricted": "Sì, ad alcune condizioni",
        "uncategorized": "Non specificato"
      },
      "select": "Selezionare se è possibile utilizzarlo"
    },
    "TYPE": {
      "name": "Tipo di supporto",
      "options": {
        "3D": "3D",
        "IMAGE": "Immagine",
        "SOUND": "Audio",
        "TEXT": "Testo",
        "VIDEO": "Video"
      },
      "select": "Seleziona i tipi di media"
    },
    "api": {
      "name": "Cerca",
      "options": {
        "fulltext": "Oggetti con testo completo",
        "metadata": "Oggetti con solo metadati"
      },
      "switch": "Cerca solo nel contenuto degli articoli con testo completo",
      "switchMoreInfo": "In questa raccolta puoi scegliere cosa cercare: se questo interruttore è attivo, cercherai all'interno del giornale e del testo del documento; se è spento, cercherai invece all'interno delle informazioni che descrivono l'articolo, proprio come fai sempre nella maggior parte delle altre collezioni."
    },
    "button": {
      "apply": "Applica",
      "cancel": "Annulla",
      "morefilters": "Altri filtri",
      "reset": "Ripristina",
      "showAll": "{label}: mostra tutto",
      "showLess": "{label}: mostra meno"
    },
    "collection": {
      "name": "Tema",
      "options": {
        "archaeology": "Archeologia",
        "art": "Arte",
        "fashion": "Moda",
        "industrial": "Patrimonio industriale",
        "manuscript": "Manoscritti",
        "map": "Mappe e geografia",
        "migration": "Migrazione",
        "music": "Musica",
        "nature": "Storia naturale",
        "newspaper": "Quotidiani",
        "photography": "Fotografia",
        "sport": "Sport",
        "ww1": "Prima guerra mondiale"
      },
      "select": "Seleziona un tema"
    },
    "contentTier": {
      "name": "Qualità dell'articolo",
      "options": {
        "*": "Comprende oggetti che non soddisfano i nostri criteri di pubblicazione",
        "0": "Mostra solo gli oggetti che non soddisfano i nostri criteri di pubblicazione",
        "1": "Bassa qualità",
        "2": "Qualità media",
        "3": "Alta qualità e riutilizzabile con condizioni",
        "4": "Alta qualità e liberamente riutilizzabile"
      },
      "select": "Seleziona le qualità dell'articolo"
    },
    "moreOptions": "Cerca di trovare {0} più {1}.",
    "proxy_dc_format": {
      "name": "Formato | Formati",
      "select": "Seleziona i formati"
    },
    "proxy_dc_type": {
      "name": "Tipo | Tipi",
      "select": "Seleziona i tipi"
    },
    "proxy_dcterms_issued": {
      "name": "Data di emissione"
    },
    "proxy_dcterms_medium": {
      "name": "Medium | Media",
      "select": "Seleziona media"
    }
  },
  "feedback": {
    "emailOptional": "Potremmo voler seguire. Inserisci la tua email se sei felice di essere contattato.",
    "failed": "La richiesta è fallita. Per favore riprova.",
    "form": {
      "placeholders": {
        "email": "Inserisci il tuo indirizzo email",
        "feedback": "Inserisci qui il tuo risposta"
      }
    },
    "policies": "Continuando, accetti i nostri {0} e riconosci i nostri {1} .",
    "privacyPolicy": "Informativa sulla privacy",
    "success": "Il tuo feedback è stato inviato.",
    "termsOfService": "Termini di servizio",
    "thankYou": "Grazie!",
    "title": "Invia feedback",
    "validEmail": "Inserire un indirizzo email valido",
    "validFeedback": "Il tuo feedback deve consistere in 5 parole al minimo"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Contributori",
      "dcCoverage": "Luogo-Tempo",
      "dcCreator": "Creatore",
      "dcDate": "Data",
      "dcDescription": "Descrizione",
      "dcDuration": "Durata",
      "dcFormat": "Formato",
      "dcIdentifier": "Codice di identificazione",
      "dcLanguage": "Lingua",
      "dcPublisher": "Editore",
      "dcRelation": "Relazioni",
      "dcRights": "Diritti",
      "dcSource": "Fonte",
      "dcSubject": "Argomento",
      "dcTitle": "Titolo",
      "dcType": "Tipo di oggetto",
      "dctermsCreated": "Data di creazione",
      "dctermsExtent": "Estensione",
      "dctermsHasPart": "Si compone di",
      "dctermsHasVersion": "Ha una versione",
      "dctermsIsFormatOf": "È un formato di",
      "dctermsIsPartOf": "Fa parte di",
      "dctermsIsReferencedBy": "È citato da",
      "dctermsIsReplacedBy": "È sostituito da",
      "dctermsIsRequiredBy": "È richiesto da",
      "dctermsIssued": "Data di uscita",
      "dctermsMedium": "Medium",
      "dctermsProvenance": "Provenienza",
      "dctermsReferences": "Fa riferimento a",
      "dctermsSpatial": "Luoghi",
      "dctermsTOC": "Tabella dei contenuti",
      "dctermsTemporal": "Periodo",
      "edmCountry": "Paese fornitore",
      "edmCurrentLocation": "Posizione attuale",
      "edmDataProvider": "Istituzione fornitrice",
      "edmHasMet": "Ha incontrato",
      "edmIncorporates": "Incorpora",
      "edmIntermediateProvider": "Intermediario",
      "edmIsDerivativeOf": "È derivato da",
      "edmIsRelatedTo": "È legato a",
      "edmIsRepresentationOf": "È rappresentazione di",
      "edmIsSimilarTo": "È simile a",
      "edmIsSuccessorOf": "È successore di",
      "edmProvider": "Fornitore",
      "edmRealizes": "Realizza",
      "edmRights": "Licenza del supporto in questo record (se non diversamente specificato)",
      "edmUgc": "Contenuto generato dagli utenti",
      "europeanaCollectionName": "Nome della collezione",
      "keywords": "Parole chiave (indicate dalla comunità)",
      "timestampCreated": "Timestamp creato",
      "timestampUpdate": "Timestamp aggiornato",
      "wasPresentAt": "Era presente presso",
      "year": "Anno"
    },
    "webResource": {
      "about": "Informazioni RDF",
      "dcDescription": "Descrizione",
      "ebucoreHasMimeType": "Tipo MIME Ebucore",
      "edmRights": "Licenza di questo contenuto",
      "rdfAbout": "Informazioni RDF"
    }
  },
  "filter": "Filtro",
  "filterResults": "Filtra risultati",
  "footer": {
    "customiseWebsiteLanguage": "Personalizza la lingua del sito",
    "disclaimerLine1": "Europeana è un'iniziativa dell'Unione europea, finanziata dal Connecting Europe Facility dell'Unione europea e dagli Stati membri dell'Unione europea. I servizi Europeana, compreso questo sito web, sono gestiti da un consorzio guidato dalla Fondazione Europeana nell'ambito di un contratto di servizio con la Commissione europea.",
    "disclaimerLine2": "La Commissione europea non garantisce l'accuratezza delle informazioni e non si assume alcuna responsabilità in merito alle informazioni contenute in questo sito web. Né la Commissione europea, né alcuna persona che agisce per conto della Commissione europea, è responsabile o obbligata per l'accuratezza o l'uso delle informazioni su questo sito web.",
    "findUsElsewhere": "Trovaci altrove",
    "imageDescription": "Finanziato dall'Unione Europea",
    "navigation": {
      "MoreInfoLabel": "Maggiori informazioni",
      "about": "Chi siamo",
      "accessibility": "Accessibilità",
      "cookies": "Cookie",
      "forDevelopers": "Per gli sviluppatori",
      "help": "Aiuto",
      "privacy": "Informativa sulla privacy",
      "provide": "Diventa un fornitore di dati",
      "subscribe": "Iscriviti alla newsletter",
      "terms": "Termini di utilizzo"
    },
    "ourMission": "La nostra missione",
    "ourMissionQuote": "Europeana sostiene il settore dei beni culturali nella sua trasformazione digitale. Sviluppiamo competenze, strumenti e strategie per accogliere i cambiamenti del mondo digitale e incoraggiare collaborazioni che promuovano l'innovazione."
  },
  "formatting": {
    "ellipsis": "…",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Esplora le gallerie",
    "galleries": "Gallerie"
  },
  "goToRecord": "Vai al record",
  "header": {
    "backToMenu": "Chiudi casella di ricerca",
    "clearQuery": "Elimina query di ricerca",
    "closeSidebar": "Chiudi Menu",
    "entireCollection": "Cerca {query} in tutta la collezione",
    "europeanaHome": "Home Europeana",
    "inCollection": "Cerca {query} in {collection}",
    "navigation": {
      "about": "Chi siamo",
      "collections": "Collezioni",
      "europeanaClassroom": "Per gli insegnanti",
      "help": "Aiuto",
      "home": "Home",
      "pro": "Per professionisti",
      "stories": "Storie"
    },
    "quickSearch": "Ricerca rapida",
    "searchFor": "Cerca {query}",
    "searchForEverything": "Cerca tutto",
    "searchForEverythingInCollection": "Cerca tutto in {collection}",
    "searchForEverythingInEntireCollection": "Cerca tutto nell'intera collezione",
    "searchForm": "Modulo di ricerca",
    "showSidebar": "Mostra menu",
    "sideNavigation": "Navigazione laterale"
  },
  "homeLinkAlt": "Home Europeana",
  "homePage": {
    "discoverEditorial": "Ultime storie",
    "storiesCTA": "Vedi tutte le storie",
    "subHeadline": "Ricerca, salva e condividi arte, libri, film e musica provenienti da migliaia di istituzioni culturali",
    "themesCTA": "Vedi tutti i temi",
    "themesTitle": "Esplora per tema",
    "title": "Scopri il patrimonio culturale {digital} europeo",
    "titleDigital": "digitale"
  },
  "imageSlider": {
    "handle": "Dispositivo di scorrimento"
  },
  "items": {
    "itemCount": "1 oggetto | {count} oggetti",
    "itemOf": "{max} di {count} oggetti",
    "recent": "Oggetti recenti",
    "recommended": "Oggetti consigliati",
    "youMightLike": "Oggetti che potrebbero piacerti"
  },
  "klaro": {
    "main": {
      "acceptAll": "Accettare tutti",
      "acceptSelected": "Accetta selezionato",
      "consentModal": {
        "description": "Prendiamo sul serio la privacy dei tuoi dati. Qui puoi valutare e personalizzare i servizi che vorremmo utilizzare su questo sito web. Sei tu al comando! Abilitare o disabilitare i servizi come meglio credi.",
        "title": "Servizi che vorremmo utilizzare."
      },
      "consentNotice": {
        "description": "Teniamo molto alla tua privacy e utilizziamo i dati solo per migliorare la tua esperienza. Non utilizziamo alcuna informazione personale per la pubblicità. Puoi modificare il tuo consenso ogni 15 giorni.",
        "learnMore": "Fammi scegliere"
      },
      "decline": "Rifiuto",
      "ok": "Ok",
      "purposes": {
        "essential": {
          "description": "Questi servizi sono essenziali per il corretto funzionamento di questo sito web. Includono la visualizzazione dei risultati di ricerca e le preferenze di lingua, conservano lo stato di accesso e mantengono la tua visita sicura. Non puoi disabilitarli in quanto il sito web non funzionerebbe correttamente altrimenti.",
          "title": "Servizi essenziali per la sicurezza e la personalizzazione"
        },
        "usage": {
          "description": "Questi servizi raccolgono le informazioni per aiutarci a capire meglio come viene utilizzato il sito Web e dove sono i punti deboli, consentendoci di fare scelte informate per migliorare la tua esperienza.",
          "title": "Servizi per catturare l'uso del sito web e il feedback"
        }
      },
      "service": {
        "disableAll": {
          "description": "Utilizzare questo interruttore per abilitare o disabilitare tutti i servizi facoltativi.",
          "title": "Abilitare o disabilitare tutti i servizi"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Aiuta a migliorare il nostro sito Web applicando occasionalmente modifiche sperimentali.",
        "title": "Test A/B"
      },
      "auth-strategy": {
        "description": "Ricorda la strategia di autorizzazione da utilizzare per accedere.",
        "title": "Strategia di autenticazione"
      },
      "debugSettings": {
        "description": "Aiuta il debug delle richieste API",
        "title": "Alterna il debug"
      },
      "hotjar": {
        "description": "Attiva un widget sondaggio che ti dà la possibilità di rispondere ai nostri sondaggi sulla soddisfazione dei visitatori.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Ricorda la lingua dell'interfaccia preferita per l'accesso futuro.",
        "title": "Codice lingua"
      },
      "jira-servicedesk": {
        "description": "Attiva il widget di feedback dandoti la possibilità di contattarci.",
        "title": "Jira service desk"
      },
      "matomo": {
        "description": "Raccoglie statistiche anonime su come i visitatori interagiscono con il sito web.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Mostra una notifica quando nuove funzionalità diventano disponibili.",
        "title": "Notifica di nuove funzionalità"
      },
      "searchResultsView": {
        "description": "Ricorda se preferisci vedere i risultati della ricerca in una visualizzazione elenco o griglia.",
        "title": "Visualizzazione dei risultati di ricerca (elenco/griglia)"
      }
    }
  },
  "layout": {
    "skipToMain": "Passa al contenuto della pagina"
  },
  "learnMore": "Scopri di più sulla fonte di questa descrizione",
  "loading": "Caricamento",
  "loadingResults": "Caricamento dei risultati in corso",
  "messages": {
    "copyToClipboardSuccess": "Copiato negli appunti",
    "externalContentError": "Impossibile caricare il contenuto esterno",
    "notFound": "Non trovati",
    "paginationLimitExceeded": "È possibile visualizzare solo i primi {limit} risultati di ricerca."
  },
  "modal": {
    "download": {
      "clickToCopy": "Clicca sull'attribuzione per copiarla",
      "modalIntro": "Se utilizzi questo elemento sul Web o altrove, non dimenticare di utilizzare la seguente attribuzione accanto a esso:",
      "modalTitle": "Di grazie"
    }
  },
  "multilingual": {
    "automated": "Traduzione automatica",
    "enrichment": "Arricchimento da parte dei progetti partner",
    "other": "Altre lingue",
    "stopTranslating": "Smetti di tradurre questo elemento in {0}.",
    "translateLanguage": "Vuoi vedere questo articolo in {0} ?",
    "translateQuotaError": "Il servizio di traduzione è momentaneamente non disponibile. Per favore riprova più tardi."
  },
  "newFeatureNotification": {
    "dismiss": "Chiudi",
    "readMore": "Leggi di più",
    "text": {
      "searchFilters": "Ora puoi cercare i valori nei singoli filtri; controlla!"
    }
  },
  "newWindow": "si apre in una nuova finestra",
  "noMoreResults": "Non ci sono altri risultati per la tua query di ricerca.",
  "noResults": "Nessun Risultato",
  "of": "Di",
  "organisation": {
    "city": "Città",
    "country": "Paese",
    "englishName": "Nome inglese",
    "nameAcronym": "Nome acronimo"
  },
  "pageHasLoaded": "ha caricato",
  "pageNumber": "Numero di pagina",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Nome"
        },
        "title": "Organizzazioni"
      },
      "persons": {
        "title": "Persone"
      },
      "places": {
        "title": "Posti"
      },
      "table": {
        "items": "Elementi",
        "name": "Nome"
      },
      "times": {
        "title": "Tempi"
      },
      "topics": {
        "title": "Temi"
      }
    }
  },
  "pagination": {
    "label": "Paginazione"
  },
  "readMore": "Leggi di più",
  "recommendation": {
    "prompts": {
      "accept": "Pollice su per aggiungere alla galleria",
      "reject": "Pollice verso il basso se non ti piace"
    }
  },
  "record": {
    "IIIFViewer": "Visualizzatore IIIF",
    "actions": {
      "pin": "Aggiungi l'elemento alle entità disponibili"
    },
    "allMetaData": "Tutti i metadati",
    "copyEmbedLabel": "Incorpora codice (fare clic per copiare)",
    "exploreMore": "Esplora altro",
    "extendedInformation": "Informazioni estese",
    "goodToKnow": "Caratteristiche",
    "hideAll": "Nascondi tutte le informazioni",
    "location": "Posizione",
    "locationOnMap": "Posizione sulla mappa",
    "mediaPlayer": "Lettore multimediale",
    "record": "Documentazione",
    "showAll": "Mostra tutte le informazioni",
    "similarItems": "Oggetti simili",
    "status": {
      "unpublished": "[Articolo non pubblicato]"
    },
    "transcription": "Trascrizione",
    "transcriptionDisclaimer": "Questo contenuto è stato creato dagli utenti, non dall'istituzione che ha fornito l'articolo."
  },
  "related": {
    "editorial": {
      "title": "Storie che potrebbero piacerti"
    }
  },
  "relatedCollections": "Collezioni correlate",
  "removeFilter": "Rimuovi il filtro {filterLabel}",
  "reset": "Ripristina",
  "resourceWikimedia": "Risorsa da Wikimedia Commons",
  "results": "Risultati",
  "resultsFor": "Risultati per {0}",
  "resultsLimitWarning": "Non vengono mostrati risultati aggiuntivi perché vengono visualizzati solo i primi 1.000 risultati più rilevanti. Se non hai trovato quello che stai cercando, considera la possibilità di perfezionare la tua ricerca.",
  "resultsWithin": "Risultati entro {0} {1} per {2}",
  "search": {
    "boost": {
      "placeholder": "Immettere la query di potenziamento del campo"
    },
    "title": "Cerca"
  },
  "searchHasLoaded": "{0} risultati restituiti",
  "searchPlaceholder": "Cerca oltre 50 milioni di articoli",
  "searchResults": "Cerca",
  "searchResultsFor": "{0} - Cerca",
  "searchSuggestions": "Suggerimenti di ricerca",
  "searchTier": {
    "button": {
      "hide": "Nascondi questi oggetti",
      "show": "Mostra questi oggetti"
    },
    "text": {
      "hide": "Vengono visualizzati gli oggetti che non soddisfano i nostri criteri di pubblicazione.",
      "show": "Altri oggetti corrispondono alla tua ricerca ma non soddisfano i nostri criteri di pubblicazione."
    }
  },
  "searchViews": {
    "grid": "Visualizzazione griglia",
    "list": "Visualizzazione elenco",
    "mosaic": "Vista a mosaico"
  },
  "set": {
    "actions": {
      "addTo": "Aggiungi alla galleria",
      "create": "Crea galleria",
      "createNew": "Crea una nuova galleria",
      "delete": "Elimina galleria",
      "edit": "Modifica galleria",
      "update": "Aggiorna galleria"
    },
    "form": {
      "description": "Descrizione della galleria",
      "private": "Tieni privata questa galleria",
      "required": "Campi obbligatorio",
      "title": "Nome della galleria"
    },
    "labels": {
      "curatedBy": "Curato da",
      "private": "Galleria privata"
    },
    "notifications": {
      "deleted": "Galleria eliminata.",
      "likeLimit": {
        "body": "Siamo spiacenti, ma al momento puoi mettere Mi piace a un massimo di 100 oggetti. Presto elimineremo questo limite!",
        "title": "100 Mi piace"
      },
      "updated": "L'elemento è stato aggiunto alla galleria."
    },
    "prompts": {
      "delete": "Continuare? Se elimini questa galleria, perderai tutti gli oggetti che hai aggiunto."
    }
  },
  "showLess": "Mostra meno",
  "showMore": "Mostra di più",
  "sideFilters": {
    "noOptions": "Non ci sono opzioni disponibili da selezionare",
    "search": "Cerca"
  },
  "statuses": {
    "liked": "Piaciuto",
    "pinned": "Appuntato"
  },
  "storiesPage": {
    "title": "Storie"
  },
  "website": "Sito web",
  "youMightAlsoLike": "Potrebbe piacerti anche"
};
